import moment from 'moment';

export function getBarsPatientName(barsSlot) {
  const name = barsSlot?.patient?.name?.[0];

  return name?.text || [name?.given, name?.family].filter(a => !!a).join(', ');
}

export function calculateBarsPatientAge(barsSlot) {
  const dob = barsSlot?.patient?.birthDate

  return moment().diff(dob, 'years');
}

export function getBarsAppointmentReason(barsSlot) {
  return barsSlot?.description || "-";
}

export function getBarsAppointmentSlotStart(barsSlot) {
  return moment(barsSlot?.start).toISOString();
}

export function getBarsAppointmentSlotEnd(barsSlot) {
  return moment(barsSlot?.end).toISOString();
}